/**
 * Custom Progress Bar
 * Updates the progress bar height based on scroll position in the services card wrapper
 */

export function initProgressBarCustom() {
    const scrollContainer = document.querySelector('.services-card-item-wrapper');
    const timelineActive = document.querySelector('.process-timeline-active');
    const section = document.querySelector('.section-bottom-padding-custom');
    
    if (!scrollContainer || !timelineActive) {
        return;
    }
    
    // Store original padding and set up transition for smooth animation
    let originalPadding = '';
    if (section) {
        originalPadding = window.getComputedStyle(section).paddingBottom;
        section.style.transition = 'padding-bottom 0.4s ease-out';
    }
    
    function updateTimelineProgress() {
        const scrollTop = scrollContainer.scrollTop;
        const scrollHeight = scrollContainer.scrollHeight;
        const clientHeight = scrollContainer.clientHeight;
        const maxScroll = scrollHeight - clientHeight;
        
        // Calculate scroll percentage (0 to 100)
        let scrollPercentage = 0;
        if (maxScroll > 0) {
            scrollPercentage = (scrollTop / maxScroll) * 100;
        }

        // Minimum height = 10%
        const finalHeight = Math.max(scrollPercentage, 10);

        // Update the timeline active height
        timelineActive.style.height = finalHeight + '%';
        
        // Animate padding when scroll reaches the bottom
        if (section) {
            // Check if scrolled to bottom (with small threshold for precision)
            const isAtBottom = scrollTop + clientHeight >= scrollHeight - 5;
            
            if (isAtBottom) {
                section.style.paddingBottom = '0';
            } else {
                section.style.paddingBottom = originalPadding;
            }
        }
    }
    
    // Initial update
    updateTimelineProgress();
    
    // Update on scroll with throttling for better performance
    let ticking = false;
    scrollContainer.addEventListener('scroll', function() {
        if (!ticking) {
            window.requestAnimationFrame(function() {
                updateTimelineProgress();
                ticking = false;
            });
            ticking = true;
        }
    });
}
